import entityService from "@/services/entityService";
import entity from "@/services/entity";
import Api from "../../services/Api";
import router from "../../router/index";

export const state = {
  loading: false,
  isValidSubdomain: false,
  subdomain: null,
  entities: [],
  modalState: false,
  entityStatus: null,
};

export const actions = {
  checkDomain({ commit }, params) {
    return new Promise((reject) => {
      entityService
        .checkSubdomain(params)
        .then((data) => {
          commit("setSubdomain", data.data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  checkEntitySubdomain({ commit }, params) {
    commit("authfack/loadongStatus", true, { root: true });
    return new Promise((resolve, reject) => {
      entityService
        .checkEntitySubdomain(params.subdomain, params.server)
        .then((data) => {
          resolve(data);
          let status = data.data.data;
          status && commit("authfack/loadongStatus", false, { root: true });
          commit("setIsValidSubdomain", status);
        })
        .catch((err) => {
          reject(err);
          if (err.response.status == 401) {
            actions.checkEntitySubdomain({ commit }, params);
          }
        });
    });
  },
  checkEntityStatus({ commit, rootGetters }, params) {
    return new Promise((resolve, reject) => {
      entity
        .checkEntityStatus(params.data)
        .then((data) => {
          resolve(data);
          commit("setEntityStatus", data.data);
          if (data.data) {
            const {
              entity: {
                server: { server_url },
                userId,
                entity_id,
              },
            } = params;
            const entityURL = `${server_url}/sso?id=${userId}&atex=${rootGetters["user/getUserData"].atex}&entity_id=${entity_id}&ip=${rootGetters["user/getIp"]}`;
            window.location.href = entityURL;
          } else {
            router.push("/error-revoked");
          }
        })
        .catch((err) => {
          reject(err);
          this._vm.$toast.error(err.data.message);
        });
    });
  },
  createEntity({ commit, dispatch }, params) {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      const userId = JSON.parse(localStorage.getItem("user")).data.user.id;
      let timeOut = 3000;
      let pwd = null;
      Api()
        .get(`/list-user-all-entities/${userId}?page=1`)
        .then((data) => {
          const servers = data.data.data;
          const serversApis = [];
          servers.forEach((server) => {
            serversApis.push(server.server.server_api);
          });
          // let userData = null;
            let userData = JSON.parse(localStorage.getItem("user")).data.user;
            userData.exisingUser = true;
            Api()
                .get(`/get-user-pwd/${userId}`)
                .then((d) => {
                    pwd = d.data;
                })
                .catch((err) => {
                    console.log(err);
                });
          if (!serversApis.includes(params.server.server_api)) {
              userData.exisingUser = false;
            // userData = JSON.parse(localStorage.getItem("user")).data.user;
            delete userData.atex;
            delete userData.tmp_pwd;
            delete userData.timezone;
          }
          setTimeout(() => {
            if (userData !== null) userData.password = pwd;
            params.data = userData;
            entityService
              .createEntity(params)
              .then((data) => {
                resolve(data);
                commit("setIsValidSubdomain", true);
                let entityId = data.data.data.id;
                commit("setLoading", false);
                this._vm.$toast.success("Entity Created");
                commit("setModalState", true);
                setTimeout(() => {
                  entityService
                    .attachUserToEntity(entityId)
                    .then((data) => {
                      console.log(data);
                      dispatch("user/manageCreateCompanyModal", false, {
                        root: true,
                      });
                      setTimeout(() => {
                        dispatch("entities/fetchUserEntities", null, {
                          root: true,
                        });
                      }, 5000);
                    })
                    .catch((err) => {
                      console.log(err);
                      dispatch("user/manageCreateCompanyModal", false, {
                        root: true,
                      });
                      dispatch("entities/fetchUserEntities", null, {
                        root: true,
                      });
                    });
                }, 1000);
              })
              .catch((error) => {
                reject(error);
                commit("setLoading", false);
                commit("setModalState", false);
                this._vm.$toast.error(
                  Object.values(error.response.data.errors).join("\r\n")
                );
              });
          }, timeOut);
        })
        .catch((error) => {
          console.log(error);
        });
    });
  },
  resetState({ commit }) {
    commit("setLoading", false);
    commit("setModalState", false);
  },
};

export const mutations = {
  setLoading(state, payload) {
    state.loading = payload;
  },
  setIsValidSubdomain(state, payload) {
    state.isValidSubdomain = payload;
  },
  setSubdomain(state, payload) {
    state.subdomain = payload;
  },
  setModalState(state, payload) {
    state.modalState = payload;
  },
  setEntityStatus(state, payload) {
    state.entityStatus = payload;
  },
};

export const getters = {
  getLoading(state) {
    return state.loading;
  },
  getIsValidSubdomain(state) {
    return state.isValidSubdomain;
  },
  getSubdomain(state) {
    return state.subdomain;
  },
  getModalState(state) {
    return state.modalState;
  },
  getEntityStatus(state) {
    return state.entityStatus;
  },
};
